// Generated by tools/animation/build_native_cloth_model_inventory.mjs.
// Topology metadata only; original model vertices remain in CHRM assets.

function deepFreeze(value) {
  if (!value || typeof value !== "object" || Object.isFrozen(value)) {
    return value;
  }
  Object.freeze(value);
  for (const child of Object.values(value)) deepFreeze(child);
  return value;
}

export const NATIVE_CLOTH_MODEL_METADATA = deepFreeze({
  "ACS_M": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        18,
        13,
        12,
        14,
        19,
        4,
        6,
        5,
        7,
        16,
        8,
        10,
        9,
        11,
        17,
        0,
        2,
        1,
        3,
        15
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        34
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        18,
        13,
        12,
        14,
        19,
        4,
        6,
        5,
        7,
        16,
        8,
        10,
        9,
        11,
        17,
        0,
        2,
        1,
        3,
        15
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        18,
        13,
        12,
        14,
        19,
        4,
        6,
        5,
        7,
        16,
        8,
        10,
        9,
        11,
        17,
        0,
        2,
        1,
        3,
        15
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        34
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        18,
        13,
        12,
        14,
        19,
        4,
        6,
        5,
        7,
        16,
        8,
        10,
        9,
        11,
        17,
        0,
        2,
        1,
        3,
        15
      ]
    }
  ],
  "ASD_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        9,
        6,
        7,
        11,
        8,
        5,
        4,
        10,
        2,
        0,
        1,
        3
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        9,
        6,
        7,
        11,
        8,
        5,
        4,
        10,
        2,
        0,
        1,
        3
      ]
    }
  ],
  "ASO_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        2,
        5,
        13,
        6,
        7,
        1,
        4,
        12,
        10,
        14,
        0,
        3,
        11,
        8,
        9
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        2,
        5,
        13,
        6,
        7,
        1,
        4,
        12,
        10,
        14,
        0,
        3,
        11,
        8,
        9
      ]
    }
  ],
  "BAT_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        1,
        7,
        4,
        10,
        0,
        6,
        3,
        8,
        11,
        5,
        2,
        9
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        7,
        4,
        10,
        0,
        6,
        3,
        8,
        11,
        5,
        2,
        9
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        1,
        7,
        4,
        10,
        0,
        6,
        3,
        8,
        11,
        5,
        2,
        9
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        7,
        4,
        10,
        0,
        6,
        3,
        8,
        11,
        5,
        2,
        9
      ]
    }
  ],
  "BAU_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 10,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        9,
        3,
        4,
        5,
        8,
        6,
        2,
        1,
        0,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        9,
        3,
        4,
        5,
        8,
        6,
        2,
        1,
        0,
        7
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 10,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        9,
        3,
        4,
        5,
        8,
        6,
        2,
        1,
        0,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        9,
        3,
        4,
        5,
        8,
        6,
        2,
        1,
        0,
        7
      ]
    }
  ],
  "BGA_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 18,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        15,
        13,
        17,
        16,
        12,
        14,
        6,
        7,
        8,
        9,
        10,
        11,
        0,
        1,
        2,
        3,
        4,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        15,
        13,
        17,
        16,
        12,
        14,
        6,
        7,
        8,
        9,
        10,
        11,
        0,
        1,
        2,
        3,
        4,
        5
      ]
    }
  ],
  "BGM_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        0,
        3,
        14,
        9,
        6,
        7,
        4,
        12,
        10,
        1,
        2,
        5,
        13,
        11,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        3,
        14,
        9,
        6,
        7,
        4,
        12,
        10,
        1,
        2,
        5,
        13,
        11,
        8
      ]
    }
  ],
  "BUR_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        0,
        3,
        14,
        9,
        6,
        7,
        4,
        12,
        10,
        1,
        2,
        5,
        13,
        11,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        3,
        14,
        9,
        6,
        7,
        4,
        12,
        10,
        1,
        2,
        5,
        13,
        11,
        8
      ]
    }
  ],
  "BWW_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 9,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 3,
      "closedColumns": false,
      "sourceVertexOrder": [
        8,
        5,
        6,
        7,
        4,
        3,
        2,
        0,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        1,
        1,
        1
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        8,
        5,
        6,
        7,
        4,
        3,
        2,
        0,
        1
      ]
    }
  ],
  "CHA_M": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 25,
      "hasRenderSurface": true,
      "rowCount": 5,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        15,
        1,
        0,
        13,
        12,
        14,
        2,
        3,
        10,
        11,
        20,
        19,
        16,
        17,
        22,
        6,
        5,
        9,
        18,
        23,
        7,
        4,
        8,
        21,
        24
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        33,
        0,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        0,
        35,
        0,
        0,
        0,
        0,
        36,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        0,
        0,
        0,
        0,
        0
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        15,
        1,
        0,
        13,
        12,
        14,
        2,
        3,
        10,
        11,
        20,
        19,
        16,
        17,
        22,
        6,
        5,
        9,
        18,
        23,
        7,
        4,
        8,
        21,
        24
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 5,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        10,
        9,
        5,
        3,
        11,
        12,
        6,
        2,
        13,
        14,
        17,
        4,
        15,
        16,
        7,
        0,
        19,
        18,
        8,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        35,
        0,
        0,
        0,
        36
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        10,
        9,
        5,
        3,
        11,
        12,
        6,
        2,
        13,
        14,
        17,
        4,
        15,
        16,
        7,
        0,
        19,
        18,
        8,
        1
      ]
    }
  ],
  "CHU_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 18,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        12,
        17,
        14,
        15,
        16,
        4,
        5,
        3,
        1,
        0,
        2,
        10,
        11,
        9,
        7,
        6,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        12,
        17,
        14,
        15,
        16,
        4,
        5,
        3,
        1,
        0,
        2,
        10,
        11,
        9,
        7,
        6,
        8
      ]
    }
  ],
  "CMA_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 10,
      "closedColumns": true,
      "sourceVertexOrder": [
        14,
        13,
        12,
        11,
        10,
        19,
        18,
        17,
        16,
        15,
        28,
        29,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        9,
        3,
        0,
        2,
        6,
        8,
        4,
        1,
        5,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        14,
        13,
        12,
        11,
        10,
        19,
        18,
        17,
        16,
        15,
        28,
        29,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        9,
        3,
        0,
        2,
        6,
        8,
        4,
        1,
        5,
        7
      ]
    }
  ],
  "FKS_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 16,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        6,
        4,
        5,
        15,
        9,
        7,
        8,
        10,
        13,
        11,
        12,
        14,
        2,
        0,
        1,
        3
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        6,
        4,
        5,
        15,
        9,
        7,
        8,
        10,
        13,
        11,
        12,
        14,
        2,
        0,
        1,
        3
      ]
    }
  ],
  "FRA_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 18,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        11,
        5,
        9,
        6,
        4,
        8,
        16,
        17,
        15,
        12,
        13,
        14,
        7,
        1,
        2,
        0,
        10,
        3
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        5,
        9,
        6,
        4,
        8,
        16,
        17,
        15,
        12,
        13,
        14,
        7,
        1,
        2,
        0,
        10,
        3
      ]
    }
  ],
  "FRB_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 32,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        28,
        29,
        31,
        26,
        25,
        24,
        30,
        27,
        21,
        19,
        22,
        16,
        18,
        17,
        23,
        20,
        7,
        10,
        14,
        4,
        1,
        3,
        12,
        9,
        6,
        11,
        15,
        5,
        0,
        2,
        13,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        28,
        29,
        31,
        26,
        25,
        24,
        30,
        27,
        21,
        19,
        22,
        16,
        18,
        17,
        23,
        20,
        7,
        10,
        14,
        4,
        1,
        3,
        12,
        9,
        6,
        11,
        15,
        5,
        0,
        2,
        13,
        8
      ]
    }
  ],
  "FRG_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 14,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 7,
      "closedColumns": true,
      "sourceVertexOrder": [
        1,
        0,
        6,
        5,
        4,
        2,
        3,
        7,
        8,
        9,
        11,
        12,
        13,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        0,
        6,
        5,
        4,
        2,
        3,
        7,
        8,
        9,
        11,
        12,
        13,
        10
      ]
    }
  ],
  "FRO_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        9,
        17,
        18,
        0,
        19,
        1,
        4,
        7,
        11,
        14,
        2,
        5,
        8,
        12,
        15,
        3,
        6,
        10,
        13,
        16
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        9,
        17,
        18,
        0,
        19,
        1,
        4,
        7,
        11,
        14,
        2,
        5,
        8,
        12,
        15,
        3,
        6,
        10,
        13,
        16
      ]
    }
  ],
  "FUU_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 8,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        4,
        7,
        6,
        5,
        3,
        1,
        0,
        2
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        4,
        7,
        6,
        5,
        3,
        1,
        0,
        2
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 8,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        6,
        5,
        4,
        2,
        3,
        0,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        6,
        5,
        4,
        2,
        3,
        0,
        1
      ]
    }
  ],
  "FUW_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 3,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        8,
        9,
        10,
        7,
        6,
        4,
        0,
        1,
        5,
        3,
        2
      ],
      "anchorBindings": [
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        1,
        1,
        1,
        1
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        8,
        9,
        10,
        7,
        6,
        4,
        0,
        1,
        5,
        3,
        2
      ]
    }
  ],
  "GRL_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 8,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        1,
        3,
        2,
        4,
        5,
        7,
        6,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        3,
        2,
        4,
        5,
        7,
        6,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 8,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        5,
        4,
        6,
        3,
        0,
        1,
        2
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        5,
        4,
        6,
        3,
        0,
        1,
        2
      ]
    }
  ],
  "HND_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 40,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 10,
      "closedColumns": true,
      "sourceVertexOrder": [
        4,
        3,
        2,
        1,
        0,
        9,
        8,
        7,
        6,
        5,
        39,
        33,
        30,
        32,
        36,
        38,
        34,
        31,
        35,
        37,
        19,
        17,
        15,
        13,
        11,
        29,
        27,
        25,
        23,
        21,
        18,
        16,
        14,
        12,
        10,
        28,
        26,
        24,
        22,
        20
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        4,
        3,
        2,
        1,
        0,
        9,
        8,
        7,
        6,
        5,
        39,
        33,
        30,
        32,
        36,
        38,
        34,
        31,
        35,
        37,
        19,
        17,
        15,
        13,
        11,
        29,
        27,
        25,
        23,
        21,
        18,
        16,
        14,
        12,
        10,
        28,
        26,
        24,
        22,
        20
      ]
    }
  ],
  "HOB_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 32,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        9,
        10,
        30,
        22,
        21,
        23,
        31,
        11,
        0,
        1,
        24,
        13,
        12,
        14,
        25,
        2,
        3,
        4,
        26,
        16,
        15,
        17,
        27,
        5,
        6,
        7,
        28,
        19,
        18,
        20,
        29,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        9,
        10,
        30,
        22,
        21,
        23,
        31,
        11,
        0,
        1,
        24,
        13,
        12,
        14,
        25,
        2,
        3,
        4,
        26,
        16,
        15,
        17,
        27,
        5,
        6,
        7,
        28,
        19,
        18,
        20,
        29,
        8
      ]
    }
  ],
  "HOS_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 48,
      "hasRenderSurface": false,
      "rowCount": 6,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        8,
        6,
        22,
        15,
        17,
        16,
        23,
        7,
        47,
        45,
        40,
        42,
        43,
        44,
        41,
        46,
        1,
        4,
        20,
        13,
        10,
        12,
        18,
        3,
        34,
        36,
        39,
        38,
        37,
        35,
        32,
        33,
        29,
        30,
        31,
        27,
        25,
        26,
        24,
        28,
        0,
        5,
        21,
        14,
        9,
        11,
        19,
        2
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": null
    }
  ],
  "HPD_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 8,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        3,
        1,
        5,
        6,
        2,
        0,
        4,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        3,
        1,
        5,
        6,
        2,
        0,
        4,
        7
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 8,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        1,
        3,
        5,
        6,
        0,
        2,
        4,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        3,
        5,
        6,
        0,
        2,
        4,
        7
      ]
    },
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 28,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 7,
      "closedColumns": true,
      "sourceVertexOrder": [
        8,
        17,
        14,
        2,
        3,
        18,
        11,
        7,
        16,
        13,
        1,
        4,
        19,
        10,
        25,
        23,
        22,
        21,
        24,
        26,
        27,
        6,
        15,
        12,
        0,
        5,
        20,
        9
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        34
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        8,
        17,
        14,
        2,
        3,
        18,
        11,
        7,
        16,
        13,
        1,
        4,
        19,
        10,
        25,
        23,
        22,
        21,
        24,
        26,
        27,
        6,
        15,
        12,
        0,
        5,
        20,
        9
      ]
    }
  ],
  "HPF_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        8,
        6,
        5,
        11,
        7,
        2,
        1,
        9,
        4,
        3,
        0,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        8,
        6,
        5,
        11,
        7,
        2,
        1,
        9,
        4,
        3,
        0,
        10
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        5,
        4,
        11,
        8,
        3,
        0,
        9,
        6,
        2,
        1,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        5,
        4,
        11,
        8,
        3,
        0,
        9,
        6,
        2,
        1,
        10
      ]
    }
  ],
  "HPI_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 32,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        30,
        27,
        29,
        28,
        31,
        24,
        25,
        26,
        18,
        14,
        17,
        16,
        21,
        13,
        12,
        15,
        19,
        0,
        1,
        10,
        20,
        8,
        7,
        2,
        23,
        4,
        3,
        11,
        22,
        9,
        6,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        30,
        27,
        29,
        28,
        31,
        24,
        25,
        26,
        18,
        14,
        17,
        16,
        21,
        13,
        12,
        15,
        19,
        0,
        1,
        10,
        20,
        8,
        7,
        2,
        23,
        4,
        3,
        11,
        22,
        9,
        6,
        5
      ]
    }
  ],
  "HPJ_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 6,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        3,
        4,
        1,
        0,
        2,
        29,
        28,
        26,
        25,
        27,
        18,
        17,
        6,
        5,
        7,
        19,
        16,
        11,
        12,
        13,
        24,
        22,
        23,
        21,
        20,
        14,
        15,
        9,
        8,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        0,
        35,
        0,
        0,
        0,
        0,
        36
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        3,
        4,
        1,
        0,
        2,
        29,
        28,
        26,
        25,
        27,
        18,
        17,
        6,
        5,
        7,
        19,
        16,
        11,
        12,
        13,
        24,
        22,
        23,
        21,
        20,
        14,
        15,
        9,
        8,
        10
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 6,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        4,
        0,
        3,
        1,
        2,
        29,
        28,
        27,
        25,
        26,
        17,
        16,
        7,
        6,
        5,
        18,
        15,
        11,
        12,
        13,
        20,
        24,
        21,
        22,
        23,
        19,
        14,
        10,
        9,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        0,
        35,
        0,
        0,
        0,
        0,
        36
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        4,
        0,
        3,
        1,
        2,
        29,
        28,
        27,
        25,
        26,
        17,
        16,
        7,
        6,
        5,
        18,
        15,
        11,
        12,
        13,
        20,
        24,
        21,
        22,
        23,
        19,
        14,
        10,
        9,
        8
      ]
    }
  ],
  "HPX_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        4,
        9,
        10,
        2,
        1,
        5,
        7,
        8,
        11,
        3,
        0,
        6,
        19,
        18,
        20,
        21,
        22,
        23,
        15,
        16,
        17,
        13,
        12,
        14
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        4,
        9,
        10,
        2,
        1,
        5,
        7,
        8,
        11,
        3,
        0,
        6,
        19,
        18,
        20,
        21,
        22,
        23,
        15,
        16,
        17,
        13,
        12,
        14
      ]
    }
  ],
  "HPY_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 18,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        3,
        2,
        0,
        1,
        5,
        4,
        13,
        17,
        16,
        15,
        14,
        12,
        9,
        8,
        6,
        7,
        11,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        3,
        2,
        0,
        1,
        5,
        4,
        13,
        17,
        16,
        15,
        14,
        12,
        9,
        8,
        6,
        7,
        11,
        10
      ]
    }
  ],
  "HSA_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 5,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        16,
        14,
        15,
        8,
        17,
        23,
        22,
        18,
        20,
        19,
        21,
        0,
        1,
        11,
        9,
        7,
        2,
        29,
        24,
        26,
        28,
        27,
        25,
        4,
        3,
        12,
        10,
        6,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        16,
        14,
        15,
        8,
        17,
        23,
        22,
        18,
        20,
        19,
        21,
        0,
        1,
        11,
        9,
        7,
        2,
        29,
        24,
        26,
        28,
        27,
        25,
        4,
        3,
        12,
        10,
        6,
        5
      ]
    }
  ],
  "HSB_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 5,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        16,
        14,
        15,
        8,
        17,
        23,
        22,
        18,
        20,
        19,
        21,
        0,
        1,
        11,
        9,
        7,
        2,
        29,
        24,
        26,
        28,
        27,
        25,
        4,
        3,
        12,
        10,
        6,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        16,
        14,
        15,
        8,
        17,
        23,
        22,
        18,
        20,
        19,
        21,
        0,
        1,
        11,
        9,
        7,
        2,
        29,
        24,
        26,
        28,
        27,
        25,
        4,
        3,
        12,
        10,
        6,
        5
      ]
    }
  ],
  "INE_M": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 70,
      "hasRenderSurface": true,
      "rowCount": 7,
      "columnCount": 10,
      "closedColumns": true,
      "sourceVertexOrder": [
        0,
        2,
        58,
        23,
        21,
        22,
        24,
        26,
        57,
        1,
        19,
        18,
        56,
        53,
        54,
        55,
        52,
        25,
        69,
        20,
        17,
        16,
        68,
        45,
        46,
        28,
        27,
        47,
        59,
        3,
        5,
        4,
        64,
        30,
        31,
        32,
        29,
        48,
        60,
        6,
        8,
        7,
        65,
        34,
        35,
        36,
        33,
        49,
        61,
        9,
        11,
        10,
        66,
        38,
        39,
        40,
        37,
        50,
        62,
        12,
        14,
        13,
        67,
        42,
        43,
        44,
        41,
        51,
        63,
        15
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        2,
        58,
        23,
        21,
        22,
        24,
        26,
        57,
        1,
        19,
        18,
        56,
        53,
        54,
        55,
        52,
        25,
        69,
        20,
        17,
        16,
        68,
        45,
        46,
        28,
        27,
        47,
        59,
        3,
        5,
        4,
        64,
        30,
        31,
        32,
        29,
        48,
        60,
        6,
        8,
        7,
        65,
        34,
        35,
        36,
        33,
        49,
        61,
        9,
        11,
        10,
        66,
        38,
        39,
        40,
        37,
        50,
        62,
        12,
        14,
        13,
        67,
        42,
        43,
        44,
        41,
        51,
        63,
        15
      ]
    }
  ],
  "JEA_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        2,
        13,
        6,
        12,
        5,
        1,
        15,
        7,
        14,
        4,
        0,
        17,
        8,
        16,
        3,
        9,
        19,
        11,
        18,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        2,
        13,
        6,
        12,
        5,
        1,
        15,
        7,
        14,
        4,
        0,
        17,
        8,
        16,
        3,
        9,
        19,
        11,
        18,
        10
      ]
    }
  ],
  "JMA_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 21,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 7,
      "closedColumns": true,
      "sourceVertexOrder": [
        14,
        13,
        20,
        5,
        6,
        8,
        16,
        12,
        9,
        18,
        1,
        2,
        7,
        17,
        11,
        10,
        19,
        0,
        3,
        4,
        15
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        14,
        13,
        20,
        5,
        6,
        8,
        16,
        12,
        9,
        18,
        1,
        2,
        7,
        17,
        11,
        10,
        19,
        0,
        3,
        4,
        15
      ]
    }
  ],
  "JMB_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 8,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        0,
        1,
        4,
        6,
        2,
        3,
        5,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        1,
        4,
        6,
        2,
        3,
        5,
        7
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 10,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        0,
        1,
        4,
        6,
        7,
        2,
        3,
        5,
        8,
        9
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        1,
        4,
        6,
        7,
        2,
        3,
        5,
        8,
        9
      ]
    }
  ],
  "JMC_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    }
  ],
  "JMD_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    }
  ],
  "JME_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        8,
        7,
        9,
        10,
        2,
        1,
        4,
        6,
        3,
        0,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        8,
        7,
        9,
        10,
        2,
        1,
        4,
        6,
        3,
        0,
        5
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        10,
        8,
        6,
        7,
        11,
        5,
        0,
        1,
        9,
        4,
        3,
        2
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        10,
        8,
        6,
        7,
        11,
        5,
        0,
        1,
        9,
        4,
        3,
        2
      ]
    }
  ],
  "JMF_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        8,
        7,
        9,
        10,
        2,
        1,
        4,
        6,
        3,
        0,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        8,
        7,
        9,
        10,
        2,
        1,
        4,
        6,
        3,
        0,
        5
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        10,
        8,
        6,
        7,
        11,
        5,
        0,
        1,
        9,
        4,
        3,
        2
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        10,
        8,
        6,
        7,
        11,
        5,
        0,
        1,
        9,
        4,
        3,
        2
      ]
    }
  ],
  "JMG_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 21,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 7,
      "closedColumns": true,
      "sourceVertexOrder": [
        10,
        13,
        9,
        11,
        7,
        8,
        12,
        17,
        16,
        15,
        14,
        20,
        19,
        18,
        1,
        0,
        6,
        5,
        4,
        3,
        2
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        10,
        13,
        9,
        11,
        7,
        8,
        12,
        17,
        16,
        15,
        14,
        20,
        19,
        18,
        1,
        0,
        6,
        5,
        4,
        3,
        2
      ]
    }
  ],
  "KAS_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        4,
        2,
        0,
        1,
        3,
        20,
        15,
        16,
        17,
        18,
        19,
        22,
        12,
        10,
        8,
        9,
        11,
        21,
        7,
        13,
        14,
        5,
        6,
        23
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        4,
        2,
        0,
        1,
        3,
        20,
        15,
        16,
        17,
        18,
        19,
        22,
        12,
        10,
        8,
        9,
        11,
        21,
        7,
        13,
        14,
        5,
        6,
        23
      ]
    }
  ],
  "KEB_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ]
    }
  ],
  "KHI_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 18,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        12,
        17,
        14,
        15,
        16,
        4,
        5,
        3,
        1,
        0,
        2,
        10,
        11,
        9,
        7,
        6,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        12,
        17,
        14,
        15,
        16,
        4,
        5,
        3,
        1,
        0,
        2,
        10,
        11,
        9,
        7,
        6,
        8
      ]
    }
  ],
  "KIM_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 21,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 7,
      "closedColumns": true,
      "sourceVertexOrder": [
        1,
        2,
        20,
        5,
        4,
        3,
        0,
        10,
        9,
        19,
        8,
        6,
        7,
        11,
        13,
        16,
        18,
        17,
        12,
        15,
        14
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        2,
        20,
        5,
        4,
        3,
        0,
        10,
        9,
        19,
        8,
        6,
        7,
        11,
        13,
        16,
        18,
        17,
        12,
        15,
        14
      ]
    }
  ],
  "KIS_M": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 32,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        31,
        29,
        28,
        26,
        24,
        25,
        27,
        30,
        9,
        12,
        23,
        16,
        18,
        17,
        22,
        11,
        10,
        8,
        15,
        21,
        19,
        20,
        13,
        14,
        7,
        1,
        4,
        3,
        6,
        2,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        31,
        29,
        28,
        26,
        24,
        25,
        27,
        30,
        9,
        12,
        23,
        16,
        18,
        17,
        22,
        11,
        10,
        8,
        15,
        21,
        19,
        20,
        13,
        14,
        7,
        1,
        4,
        3,
        6,
        2,
        5,
        0
      ]
    }
  ],
  "KJM_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        2,
        4,
        0,
        1,
        5,
        3,
        8,
        10,
        6,
        7,
        11,
        9
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        2,
        4,
        0,
        1,
        5,
        3,
        8,
        10,
        6,
        7,
        11,
        9
      ]
    }
  ],
  "KMB_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 10,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        8,
        7,
        6,
        5,
        4,
        3,
        0,
        1,
        2,
        9
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        8,
        7,
        6,
        5,
        4,
        3,
        0,
        1,
        2,
        9
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 10,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        6,
        3,
        9,
        4,
        5,
        1,
        2,
        8,
        0,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        6,
        3,
        9,
        4,
        5,
        1,
        2,
        8,
        0,
        7
      ]
    }
  ],
  "KMN_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        1,
        0,
        16,
        8,
        9,
        3,
        2,
        17,
        10,
        11,
        5,
        4,
        18,
        12,
        13,
        7,
        6,
        19,
        14,
        15
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        32,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        0,
        0,
        0,
        0
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        0,
        16,
        8,
        9,
        3,
        2,
        17,
        10,
        11,
        5,
        4,
        18,
        12,
        13,
        7,
        6,
        19,
        14,
        15
      ]
    }
  ],
  "KOK_M": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 49,
      "hasRenderSurface": true,
      "rowCount": 7,
      "columnCount": 7,
      "closedColumns": false,
      "sourceVertexOrder": [
        45,
        44,
        43,
        47,
        42,
        46,
        48,
        34,
        3,
        1,
        4,
        0,
        2,
        33,
        32,
        8,
        6,
        9,
        5,
        7,
        31,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        30,
        13,
        11,
        14,
        10,
        12,
        29,
        28,
        18,
        16,
        19,
        15,
        17,
        27,
        25,
        23,
        21,
        24,
        20,
        22,
        26
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        45,
        44,
        43,
        47,
        42,
        46,
        48,
        34,
        3,
        1,
        4,
        0,
        2,
        33,
        32,
        8,
        6,
        9,
        5,
        7,
        31,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        30,
        13,
        11,
        14,
        10,
        12,
        29,
        28,
        18,
        16,
        19,
        15,
        17,
        27,
        25,
        23,
        21,
        24,
        20,
        22,
        26
      ]
    },
    {
      "controlType": -72,
      "renderType": 87,
      "vertexCount": 49,
      "hasRenderSurface": true,
      "rowCount": 7,
      "columnCount": 7,
      "closedColumns": false,
      "sourceVertexOrder": [
        46,
        47,
        43,
        45,
        42,
        44,
        48,
        34,
        3,
        1,
        4,
        0,
        2,
        33,
        32,
        8,
        6,
        9,
        5,
        7,
        31,
        41,
        40,
        39,
        38,
        37,
        36,
        35,
        30,
        13,
        11,
        14,
        10,
        12,
        29,
        28,
        18,
        16,
        19,
        15,
        17,
        27,
        25,
        23,
        21,
        24,
        20,
        22,
        26
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        46,
        47,
        43,
        45,
        42,
        44,
        48,
        34,
        3,
        1,
        4,
        0,
        2,
        33,
        32,
        8,
        6,
        9,
        5,
        7,
        31,
        41,
        40,
        39,
        38,
        37,
        36,
        35,
        30,
        13,
        11,
        14,
        10,
        12,
        29,
        28,
        18,
        16,
        19,
        15,
        17,
        27,
        25,
        23,
        21,
        24,
        20,
        22,
        26
      ]
    }
  ],
  "KOT_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 30,
      "hasRenderSurface": false,
      "rowCount": 5,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        7,
        2,
        0,
        6,
        9,
        8,
        17,
        15,
        13,
        12,
        14,
        16,
        23,
        22,
        20,
        19,
        18,
        21,
        29,
        28,
        26,
        25,
        24,
        27,
        1,
        5,
        3,
        4,
        10,
        11
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": null
    }
  ],
  "KUU_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 18,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        1,
        4,
        0,
        5,
        3,
        2,
        16,
        17,
        15,
        12,
        13,
        14,
        10,
        11,
        9,
        7,
        6,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        4,
        0,
        5,
        3,
        2,
        16,
        17,
        15,
        12,
        13,
        14,
        10,
        11,
        9,
        7,
        6,
        8
      ]
    }
  ],
  "KVB_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ]
    }
  ],
  "KVC_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ]
    }
  ],
  "KVD_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ]
    }
  ],
  "KVE_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ]
    }
  ],
  "KVF_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ]
    }
  ],
  "KVG_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ]
    }
  ],
  "KVH_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ]
    }
  ],
  "KVI_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        8,
        3,
        5,
        1,
        9,
        6,
        11,
        17,
        20,
        21,
        22,
        16,
        18,
        10,
        19,
        12,
        7,
        15,
        4,
        0,
        2,
        23,
        14
      ]
    }
  ],
  "KVJ_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ]
    }
  ],
  "KVK_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ]
    }
  ],
  "KVL_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        11,
        6,
        9,
        1,
        5,
        3,
        8,
        17,
        19,
        10,
        18,
        16,
        22,
        21,
        20,
        12,
        14,
        23,
        2,
        0,
        4,
        15,
        7
      ]
    }
  ],
  "KWD_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 42,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 14,
      "closedColumns": true,
      "sourceVertexOrder": [
        16,
        10,
        25,
        3,
        26,
        11,
        14,
        0,
        23,
        2,
        21,
        1,
        19,
        4,
        38,
        37,
        36,
        35,
        34,
        33,
        32,
        30,
        31,
        29,
        28,
        41,
        40,
        39,
        17,
        13,
        24,
        8,
        27,
        12,
        15,
        5,
        22,
        9,
        20,
        7,
        18,
        6
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        7,
        7,
        7
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        16,
        10,
        25,
        3,
        26,
        11,
        14,
        0,
        23,
        2,
        21,
        1,
        19,
        4,
        38,
        37,
        36,
        35,
        34,
        33,
        32,
        30,
        31,
        29,
        28,
        41,
        40,
        39,
        17,
        13,
        24,
        8,
        27,
        12,
        15,
        5,
        22,
        9,
        20,
        7,
        18,
        6
      ]
    }
  ],
  "KYF_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 28,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 7,
      "closedColumns": true,
      "sourceVertexOrder": [
        0,
        2,
        3,
        16,
        20,
        24,
        1,
        9,
        10,
        13,
        17,
        21,
        25,
        8,
        7,
        11,
        14,
        18,
        22,
        27,
        6,
        4,
        12,
        15,
        19,
        23,
        26,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        2,
        3,
        16,
        20,
        24,
        1,
        9,
        10,
        13,
        17,
        21,
        25,
        8,
        7,
        11,
        14,
        18,
        22,
        27,
        6,
        4,
        12,
        15,
        19,
        23,
        26,
        5
      ]
    }
  ],
  "KYK_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 32,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        3,
        7,
        15,
        1,
        2,
        8,
        0,
        4,
        29,
        27,
        26,
        24,
        25,
        28,
        31,
        30,
        12,
        5,
        14,
        11,
        10,
        13,
        6,
        9,
        21,
        16,
        23,
        20,
        19,
        22,
        17,
        18
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        3,
        7,
        15,
        1,
        2,
        8,
        0,
        4,
        29,
        27,
        26,
        24,
        25,
        28,
        31,
        30,
        12,
        5,
        14,
        11,
        10,
        13,
        6,
        9,
        21,
        16,
        23,
        20,
        19,
        22,
        17,
        18
      ]
    }
  ],
  "KYS_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 32,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        15,
        1,
        4,
        2,
        13,
        3,
        0,
        5,
        23,
        17,
        16,
        20,
        22,
        21,
        19,
        18,
        27,
        26,
        31,
        29,
        30,
        28,
        24,
        25,
        14,
        6,
        7,
        11,
        12,
        10,
        9,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        15,
        1,
        4,
        2,
        13,
        3,
        0,
        5,
        23,
        17,
        16,
        20,
        22,
        21,
        19,
        18,
        27,
        26,
        31,
        29,
        30,
        28,
        24,
        25,
        14,
        6,
        7,
        11,
        12,
        10,
        9,
        8
      ]
    }
  ],
  "MAL_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 21,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 7,
      "closedColumns": false,
      "sourceVertexOrder": [
        10,
        12,
        15,
        14,
        16,
        13,
        11,
        1,
        3,
        17,
        9,
        18,
        7,
        4,
        0,
        2,
        19,
        8,
        20,
        5,
        6
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        10,
        12,
        15,
        14,
        16,
        13,
        11,
        1,
        3,
        17,
        9,
        18,
        7,
        4,
        0,
        2,
        19,
        8,
        20,
        5,
        6
      ]
    }
  ],
  "MIB_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 60,
      "hasRenderSurface": true,
      "rowCount": 6,
      "columnCount": 10,
      "closedColumns": true,
      "sourceVertexOrder": [
        16,
        20,
        39,
        30,
        35,
        28,
        26,
        17,
        22,
        0,
        18,
        21,
        38,
        31,
        34,
        29,
        27,
        23,
        24,
        6,
        45,
        42,
        44,
        43,
        41,
        40,
        49,
        48,
        47,
        46,
        1,
        4,
        37,
        14,
        33,
        12,
        10,
        19,
        7,
        3,
        56,
        55,
        53,
        51,
        57,
        59,
        58,
        50,
        52,
        54,
        2,
        5,
        36,
        15,
        32,
        13,
        11,
        25,
        8,
        9
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        16,
        20,
        39,
        30,
        35,
        28,
        26,
        17,
        22,
        0,
        18,
        21,
        38,
        31,
        34,
        29,
        27,
        23,
        24,
        6,
        45,
        42,
        44,
        43,
        41,
        40,
        49,
        48,
        47,
        46,
        1,
        4,
        37,
        14,
        33,
        12,
        10,
        19,
        7,
        3,
        56,
        55,
        53,
        51,
        57,
        59,
        58,
        50,
        52,
        54,
        2,
        5,
        36,
        15,
        32,
        13,
        11,
        25,
        8,
        9
      ]
    }
  ],
  "MRU_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        1,
        0,
        12,
        6,
        7,
        3,
        2,
        13,
        8,
        9,
        5,
        4,
        14,
        10,
        11
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        0,
        12,
        6,
        7,
        3,
        2,
        13,
        8,
        9,
        5,
        4,
        14,
        10,
        11
      ]
    }
  ],
  "MYT_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        10,
        9,
        7,
        8,
        6,
        12,
        15,
        11,
        23,
        21,
        17,
        20,
        19,
        18,
        16,
        22,
        14,
        0,
        3,
        2,
        13,
        4,
        5,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        10,
        9,
        7,
        8,
        6,
        12,
        15,
        11,
        23,
        21,
        17,
        20,
        19,
        18,
        16,
        22,
        14,
        0,
        3,
        2,
        13,
        4,
        5,
        1
      ]
    }
  ],
  "NAN_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 40,
      "hasRenderSurface": true,
      "rowCount": 5,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        6,
        1,
        19,
        2,
        7,
        3,
        4,
        5,
        26,
        33,
        9,
        34,
        22,
        21,
        23,
        25,
        16,
        36,
        20,
        35,
        18,
        17,
        14,
        15,
        29,
        37,
        30,
        38,
        31,
        32,
        27,
        28,
        13,
        0,
        24,
        39,
        12,
        11,
        8,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        6,
        1,
        19,
        2,
        7,
        3,
        4,
        5,
        26,
        33,
        9,
        34,
        22,
        21,
        23,
        25,
        16,
        36,
        20,
        35,
        18,
        17,
        14,
        15,
        29,
        37,
        30,
        38,
        31,
        32,
        27,
        28,
        13,
        0,
        24,
        39,
        12,
        11,
        8,
        10
      ]
    }
  ],
  "NAT_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 5,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        14,
        12,
        11,
        19,
        13,
        9,
        10,
        18,
        8,
        7,
        6,
        17,
        5,
        4,
        3,
        16,
        2,
        1,
        0,
        15
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        35
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        14,
        12,
        11,
        19,
        13,
        9,
        10,
        18,
        8,
        7,
        6,
        17,
        5,
        4,
        3,
        16,
        2,
        1,
        0,
        15
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 5,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        14,
        12,
        11,
        19,
        13,
        9,
        10,
        18,
        8,
        7,
        6,
        17,
        5,
        4,
        3,
        16,
        2,
        1,
        0,
        15
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        35
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        14,
        12,
        11,
        19,
        13,
        9,
        10,
        18,
        8,
        7,
        6,
        17,
        5,
        4,
        3,
        16,
        2,
        1,
        0,
        15
      ]
    },
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 42,
      "hasRenderSurface": true,
      "rowCount": 7,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        28,
        27,
        26,
        25,
        24,
        29,
        4,
        3,
        2,
        1,
        0,
        15,
        5,
        8,
        7,
        6,
        9,
        16,
        33,
        35,
        34,
        32,
        30,
        31,
        18,
        21,
        19,
        20,
        22,
        23,
        39,
        41,
        40,
        38,
        36,
        37,
        12,
        14,
        13,
        10,
        11,
        17
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        28,
        27,
        26,
        25,
        24,
        29,
        4,
        3,
        2,
        1,
        0,
        15,
        5,
        8,
        7,
        6,
        9,
        16,
        33,
        35,
        34,
        32,
        30,
        31,
        18,
        21,
        19,
        20,
        22,
        23,
        39,
        41,
        40,
        38,
        36,
        37,
        12,
        14,
        13,
        10,
        11,
        17
      ]
    }
  ],
  "NKK_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        21,
        19,
        23,
        22,
        20,
        18,
        17,
        13,
        14,
        15,
        12,
        16,
        11,
        5,
        3,
        6,
        4,
        9,
        10,
        0,
        1,
        7,
        2,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        0,
        34
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        21,
        19,
        23,
        22,
        20,
        18,
        17,
        13,
        14,
        15,
        12,
        16,
        11,
        5,
        3,
        6,
        4,
        9,
        10,
        0,
        1,
        7,
        2,
        8
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        20,
        21,
        23,
        22,
        19,
        18,
        10,
        14,
        15,
        16,
        13,
        17,
        12,
        5,
        3,
        6,
        4,
        9,
        11,
        0,
        1,
        7,
        2,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        0,
        34
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        20,
        21,
        23,
        22,
        19,
        18,
        10,
        14,
        15,
        16,
        13,
        17,
        12,
        5,
        3,
        6,
        4,
        9,
        11,
        0,
        1,
        7,
        2,
        8
      ]
    }
  ],
  "NZM_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 40,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 10,
      "closedColumns": true,
      "sourceVertexOrder": [
        16,
        0,
        22,
        17,
        26,
        28,
        35,
        30,
        39,
        20,
        18,
        6,
        24,
        23,
        27,
        29,
        34,
        31,
        38,
        21,
        1,
        3,
        7,
        19,
        10,
        12,
        33,
        14,
        37,
        4,
        2,
        9,
        8,
        25,
        11,
        13,
        32,
        15,
        36,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        16,
        0,
        22,
        17,
        26,
        28,
        35,
        30,
        39,
        20,
        18,
        6,
        24,
        23,
        27,
        29,
        34,
        31,
        38,
        21,
        1,
        3,
        7,
        19,
        10,
        12,
        33,
        14,
        37,
        4,
        2,
        9,
        8,
        25,
        11,
        13,
        32,
        15,
        36,
        5
      ]
    }
  ],
  "OBA_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 18,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        3,
        10,
        11,
        0,
        9,
        8,
        12,
        14,
        16,
        17,
        15,
        13,
        5,
        4,
        6,
        7,
        2,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        3,
        10,
        11,
        0,
        9,
        8,
        17,
        15,
        13,
        12,
        14,
        16,
        5,
        4,
        6,
        7,
        2,
        1
      ]
    }
  ],
  "ONL_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        15,
        19,
        21,
        18,
        14,
        17,
        20,
        16,
        11,
        9,
        22,
        7,
        6,
        8,
        12,
        10,
        3,
        2,
        23,
        4,
        5,
        1,
        13,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        15,
        19,
        21,
        18,
        14,
        17,
        20,
        16,
        11,
        9,
        22,
        7,
        6,
        8,
        12,
        10,
        3,
        2,
        23,
        4,
        5,
        1,
        13,
        0
      ]
    }
  ],
  "OYA_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        2,
        7,
        4,
        8,
        10,
        0,
        3,
        6,
        5,
        9,
        11,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        2,
        7,
        4,
        8,
        10,
        0,
        3,
        6,
        5,
        9,
        11,
        1
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        2,
        7,
        4,
        8,
        10,
        0,
        3,
        6,
        5,
        9,
        11,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        2,
        7,
        4,
        8,
        10,
        0,
        3,
        6,
        5,
        9,
        11,
        1
      ]
    }
  ],
  "OYB_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    }
  ],
  "OYC_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    }
  ],
  "OYD_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    }
  ],
  "RFC_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        3,
        1,
        0,
        2,
        9,
        8,
        7,
        4,
        6,
        5,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        3,
        1,
        0,
        2,
        9,
        8,
        7,
        4,
        6,
        5,
        10
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        0,
        2,
        1,
        3,
        9,
        8,
        4,
        5,
        6,
        7,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        0,
        2,
        1,
        3,
        9,
        8,
        4,
        5,
        6,
        7,
        10
      ]
    }
  ],
  "RFD_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        8,
        6,
        5,
        11,
        7,
        2,
        1,
        9,
        4,
        3,
        0,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        8,
        6,
        5,
        11,
        7,
        2,
        1,
        9,
        4,
        3,
        0,
        10
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        5,
        4,
        11,
        8,
        3,
        0,
        9,
        6,
        2,
        1,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        5,
        4,
        11,
        8,
        3,
        0,
        9,
        6,
        2,
        1,
        10
      ]
    }
  ],
  "SAK_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        0,
        3,
        14,
        9,
        6,
        7,
        4,
        12,
        10,
        1,
        2,
        5,
        13,
        11,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        3,
        14,
        9,
        6,
        7,
        4,
        12,
        10,
        1,
        2,
        5,
        13,
        11,
        8
      ]
    }
  ],
  "SCA_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 27,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 9,
      "closedColumns": true,
      "sourceVertexOrder": [
        0,
        2,
        4,
        6,
        5,
        17,
        1,
        16,
        3,
        25,
        23,
        18,
        20,
        19,
        21,
        22,
        24,
        26,
        11,
        15,
        7,
        12,
        9,
        13,
        10,
        14,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        2,
        4,
        6,
        5,
        17,
        1,
        16,
        3,
        25,
        23,
        18,
        20,
        19,
        21,
        22,
        24,
        26,
        11,
        15,
        7,
        12,
        9,
        13,
        10,
        14,
        8
      ]
    }
  ],
  "SEU_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        2,
        5,
        8,
        10,
        1,
        4,
        7,
        9,
        0,
        3,
        6
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        32,
        0,
        0,
        0,
        33,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        0,
        0,
        0
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        2,
        5,
        8,
        10,
        1,
        4,
        7,
        9,
        0,
        3,
        6
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        2,
        5,
        8,
        10,
        1,
        4,
        7,
        9,
        0,
        3,
        6
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        32,
        0,
        0,
        0,
        33,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        0,
        0,
        0
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        2,
        5,
        8,
        10,
        1,
        4,
        7,
        9,
        0,
        3,
        6
      ]
    }
  ],
  "SHA_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 32,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        4,
        5,
        28,
        17,
        16,
        15,
        27,
        3,
        7,
        8,
        24,
        20,
        19,
        18,
        29,
        6,
        10,
        11,
        31,
        23,
        22,
        21,
        30,
        9,
        0,
        2,
        26,
        14,
        12,
        13,
        25,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        4,
        5,
        28,
        17,
        16,
        15,
        27,
        3,
        7,
        8,
        24,
        20,
        19,
        18,
        29,
        6,
        10,
        11,
        31,
        23,
        22,
        21,
        30,
        9,
        0,
        2,
        26,
        14,
        12,
        13,
        25,
        1
      ]
    }
  ],
  "SHE_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        1,
        2,
        3,
        5,
        4,
        0,
        21,
        23,
        19,
        20,
        22,
        18,
        12,
        11,
        14,
        7,
        8,
        16,
        13,
        10,
        15,
        6,
        9,
        17
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        2,
        3,
        5,
        4,
        0,
        21,
        23,
        19,
        20,
        22,
        18,
        12,
        11,
        14,
        7,
        8,
        16,
        13,
        10,
        15,
        6,
        9,
        17
      ]
    }
  ],
  "SHX_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 48,
      "hasRenderSurface": true,
      "rowCount": 6,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        47,
        41,
        44,
        42,
        46,
        43,
        40,
        45,
        36,
        29,
        28,
        27,
        35,
        24,
        25,
        26,
        34,
        0,
        1,
        10,
        33,
        8,
        7,
        2,
        37,
        21,
        23,
        22,
        32,
        18,
        19,
        20,
        38,
        17,
        15,
        13,
        31,
        12,
        14,
        16,
        39,
        4,
        3,
        11,
        30,
        9,
        6,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        47,
        41,
        44,
        42,
        46,
        43,
        40,
        45,
        36,
        29,
        28,
        27,
        35,
        24,
        25,
        26,
        34,
        0,
        1,
        10,
        33,
        8,
        7,
        2,
        37,
        21,
        23,
        22,
        32,
        18,
        19,
        20,
        38,
        17,
        15,
        13,
        31,
        12,
        14,
        16,
        39,
        4,
        3,
        11,
        30,
        9,
        6,
        5
      ]
    }
  ],
  "SHY_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 48,
      "hasRenderSurface": true,
      "rowCount": 6,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        47,
        41,
        44,
        42,
        46,
        43,
        40,
        45,
        36,
        29,
        28,
        27,
        35,
        24,
        25,
        26,
        34,
        0,
        1,
        10,
        33,
        8,
        7,
        2,
        37,
        21,
        23,
        22,
        32,
        18,
        19,
        20,
        38,
        17,
        15,
        13,
        31,
        12,
        14,
        16,
        39,
        4,
        3,
        11,
        30,
        9,
        6,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4,
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        47,
        41,
        44,
        42,
        46,
        43,
        40,
        45,
        36,
        29,
        28,
        27,
        35,
        24,
        25,
        26,
        34,
        0,
        1,
        10,
        33,
        8,
        7,
        2,
        37,
        21,
        23,
        22,
        32,
        18,
        19,
        20,
        38,
        17,
        15,
        13,
        31,
        12,
        14,
        16,
        39,
        4,
        3,
        11,
        30,
        9,
        6,
        5
      ]
    }
  ],
  "SIA_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        22,
        21,
        23,
        19,
        20,
        18,
        6,
        1,
        4,
        11,
        3,
        5,
        15,
        16,
        17,
        12,
        13,
        14,
        7,
        0,
        9,
        10,
        8,
        2
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        22,
        21,
        23,
        19,
        20,
        18,
        6,
        1,
        4,
        11,
        3,
        5,
        15,
        16,
        17,
        12,
        13,
        14,
        7,
        0,
        9,
        10,
        8,
        2
      ]
    }
  ],
  "SIB_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 27,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 9,
      "closedColumns": true,
      "sourceVertexOrder": [
        5,
        4,
        15,
        13,
        10,
        11,
        9,
        17,
        3,
        21,
        20,
        19,
        18,
        26,
        25,
        24,
        23,
        22,
        2,
        0,
        14,
        12,
        6,
        8,
        7,
        16,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        5,
        4,
        15,
        13,
        10,
        11,
        9,
        17,
        3,
        21,
        20,
        19,
        18,
        26,
        25,
        24,
        23,
        22,
        2,
        0,
        14,
        12,
        6,
        8,
        7,
        16,
        1
      ]
    }
  ],
  "SND_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    }
  ],
  "SNT_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 16,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        11,
        10,
        9,
        13,
        14,
        15,
        0,
        12,
        1,
        2,
        3,
        7,
        6,
        5,
        8,
        4
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        10,
        9,
        13,
        14,
        15,
        0,
        12,
        1,
        2,
        3,
        7,
        6,
        5,
        8,
        4
      ]
    }
  ],
  "SSI_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 10,
      "closedColumns": true,
      "sourceVertexOrder": [
        14,
        13,
        12,
        11,
        10,
        19,
        18,
        17,
        16,
        15,
        29,
        27,
        20,
        23,
        25,
        24,
        22,
        21,
        26,
        28,
        9,
        3,
        0,
        2,
        6,
        8,
        4,
        1,
        5,
        7
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        14,
        13,
        12,
        11,
        10,
        19,
        18,
        17,
        16,
        15,
        29,
        27,
        20,
        22,
        24,
        25,
        23,
        21,
        26,
        28,
        9,
        3,
        0,
        2,
        6,
        8,
        4,
        1,
        5,
        7
      ]
    }
  ],
  "SYU_M": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 6,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        19,
        20,
        15,
        7,
        3,
        24,
        18,
        16,
        5,
        11,
        17,
        12,
        13,
        0,
        4,
        29,
        27,
        26,
        25,
        28,
        22,
        14,
        2,
        1,
        9,
        21,
        23,
        6,
        10,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        19,
        20,
        15,
        7,
        3,
        24,
        18,
        16,
        5,
        11,
        17,
        12,
        13,
        0,
        4,
        29,
        27,
        26,
        25,
        28,
        22,
        14,
        2,
        1,
        9,
        21,
        23,
        6,
        10,
        8
      ]
    },
    {
      "controlType": -72,
      "renderType": 87,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 6,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        17,
        19,
        0,
        7,
        5,
        21,
        22,
        24,
        10,
        9,
        14,
        18,
        23,
        6,
        2,
        25,
        26,
        27,
        28,
        29,
        20,
        16,
        11,
        4,
        8,
        12,
        15,
        13,
        3,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        17,
        19,
        0,
        7,
        5,
        21,
        22,
        24,
        10,
        9,
        14,
        18,
        23,
        6,
        2,
        25,
        26,
        27,
        28,
        29,
        20,
        16,
        11,
        4,
        8,
        12,
        15,
        13,
        3,
        1
      ]
    }
  ],
  "TAT_M": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        8,
        5,
        2,
        12,
        22,
        10,
        7,
        4,
        14,
        1,
        21,
        16,
        15,
        17,
        18,
        19,
        23,
        9,
        6,
        3,
        13,
        0,
        20
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        8,
        5,
        2,
        12,
        22,
        10,
        7,
        4,
        14,
        1,
        21,
        16,
        15,
        17,
        18,
        19,
        23,
        9,
        6,
        3,
        13,
        0,
        20
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        11,
        8,
        5,
        2,
        12,
        22,
        10,
        7,
        4,
        14,
        1,
        21,
        16,
        15,
        17,
        18,
        19,
        23,
        9,
        6,
        3,
        13,
        0,
        20
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        11,
        8,
        5,
        2,
        12,
        22,
        10,
        7,
        4,
        14,
        1,
        21,
        16,
        15,
        17,
        18,
        19,
        23,
        9,
        6,
        3,
        13,
        0,
        20
      ]
    }
  ],
  "THK_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        23,
        16,
        14,
        17,
        20,
        15,
        12,
        13,
        22,
        8,
        0,
        10,
        19,
        6,
        5,
        1,
        21,
        9,
        2,
        11,
        18,
        7,
        4,
        3
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        23,
        16,
        14,
        17,
        20,
        15,
        12,
        13,
        22,
        8,
        0,
        10,
        19,
        6,
        5,
        1,
        21,
        9,
        2,
        11,
        18,
        7,
        4,
        3
      ]
    }
  ],
  "TKI_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 36,
      "hasRenderSurface": true,
      "rowCount": 6,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        1,
        3,
        0,
        4,
        2,
        5,
        19,
        25,
        26,
        28,
        30,
        20,
        21,
        24,
        27,
        29,
        23,
        18,
        12,
        14,
        13,
        15,
        17,
        16,
        34,
        22,
        35,
        33,
        31,
        32,
        7,
        9,
        6,
        10,
        8,
        11
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        1,
        3,
        0,
        4,
        2,
        5,
        19,
        25,
        26,
        28,
        30,
        20,
        21,
        24,
        27,
        29,
        23,
        18,
        12,
        14,
        13,
        15,
        17,
        16,
        34,
        22,
        35,
        33,
        31,
        32,
        7,
        9,
        6,
        10,
        8,
        11
      ]
    }
  ],
  "TOF_L": [
    {
      "controlType": -71,
      "renderType": 86,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        9,
        6,
        7,
        11,
        8,
        5,
        4,
        10,
        2,
        0,
        1,
        3
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        9,
        6,
        7,
        11,
        8,
        5,
        4,
        10,
        2,
        0,
        1,
        3
      ]
    }
  ],
  "TOK_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 30,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 10,
      "closedColumns": true,
      "sourceVertexOrder": [
        7,
        24,
        6,
        29,
        9,
        10,
        18,
        11,
        21,
        8,
        13,
        25,
        17,
        28,
        14,
        12,
        19,
        16,
        22,
        15,
        1,
        26,
        4,
        27,
        5,
        3,
        20,
        2,
        23,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        24,
        6,
        29,
        9,
        10,
        18,
        11,
        21,
        8,
        13,
        25,
        17,
        28,
        14,
        12,
        19,
        16,
        22,
        15,
        1,
        26,
        4,
        27,
        5,
        3,
        20,
        2,
        23,
        0
      ]
    }
  ],
  "TPR_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 8,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 4,
      "closedColumns": false,
      "sourceVertexOrder": [
        4,
        6,
        5,
        7,
        0,
        2,
        3,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        33,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        4,
        6,
        5,
        7,
        0,
        2,
        3,
        1
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 6,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 3,
      "closedColumns": false,
      "sourceVertexOrder": [
        5,
        3,
        4,
        0,
        2,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        1,
        1
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        5,
        3,
        4,
        0,
        2,
        1
      ]
    }
  ],
  "TUB_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        23,
        21,
        18,
        20,
        22,
        19,
        16,
        7,
        4,
        5,
        13,
        6,
        17,
        11,
        8,
        10,
        14,
        9,
        15,
        3,
        0,
        2,
        12,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        23,
        21,
        18,
        20,
        22,
        19,
        16,
        7,
        4,
        5,
        13,
        6,
        17,
        11,
        8,
        10,
        14,
        9,
        15,
        3,
        0,
        2,
        12,
        1
      ]
    }
  ],
  "UBA_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 9,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 3,
      "closedColumns": false,
      "sourceVertexOrder": [
        6,
        0,
        1,
        7,
        2,
        3,
        8,
        4,
        5
      ],
      "anchorBindings": [
        16,
        16,
        16,
        33,
        0,
        0,
        34,
        0,
        0
      ],
      "anchorSelectors": [
        1,
        1,
        1
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        6,
        0,
        1,
        7,
        2,
        3,
        8,
        4,
        5
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 9,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 3,
      "closedColumns": false,
      "sourceVertexOrder": [
        0,
        1,
        6,
        2,
        3,
        7,
        4,
        5,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        0,
        0,
        33,
        0,
        0,
        34
      ],
      "anchorSelectors": [
        1,
        1,
        1
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        0,
        1,
        6,
        2,
        3,
        7,
        4,
        5,
        8
      ]
    }
  ],
  "X61_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        16,
        0,
        14,
        13,
        17,
        15,
        22,
        20,
        19,
        18,
        21,
        23,
        7,
        6,
        4,
        12,
        5,
        2,
        8,
        3,
        9,
        11,
        10,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        16,
        0,
        14,
        13,
        17,
        15,
        22,
        20,
        19,
        18,
        21,
        23,
        7,
        6,
        4,
        12,
        5,
        2,
        8,
        3,
        9,
        11,
        10,
        1
      ]
    }
  ],
  "X77_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        22,
        23,
        21,
        5,
        3,
        2,
        18,
        15,
        12,
        4,
        0,
        1,
        19,
        16,
        13,
        10,
        9,
        8,
        20,
        17,
        14,
        11,
        7,
        6
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        22,
        23,
        21,
        5,
        3,
        2,
        18,
        15,
        12,
        4,
        0,
        1,
        19,
        16,
        13,
        10,
        9,
        8,
        20,
        17,
        14,
        11,
        7,
        6
      ]
    }
  ],
  "YAA_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        6,
        5,
        9,
        8,
        7,
        10,
        11,
        12,
        13,
        14,
        1,
        3,
        4,
        2,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        6,
        5,
        9,
        8,
        7,
        10,
        11,
        12,
        13,
        14,
        1,
        3,
        4,
        2,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        1,
        4,
        3,
        2,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        2,
        2,
        2
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        1,
        4,
        3,
        2,
        0
      ]
    }
  ],
  "YAB_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        6,
        5,
        9,
        8,
        7,
        10,
        11,
        12,
        13,
        14,
        1,
        3,
        4,
        2,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        6,
        5,
        9,
        8,
        7,
        10,
        13,
        14,
        12,
        11,
        1,
        3,
        4,
        2,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 15,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 5,
      "closedColumns": false,
      "sourceVertexOrder": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        1,
        4,
        3,
        2,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        33
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        1,
        4,
        3,
        2,
        0
      ]
    }
  ],
  "YAM_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 24,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 8,
      "closedColumns": true,
      "sourceVertexOrder": [
        15,
        16,
        18,
        12,
        13,
        14,
        19,
        17,
        6,
        7,
        22,
        0,
        1,
        2,
        21,
        8,
        9,
        10,
        23,
        3,
        4,
        5,
        20,
        11
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        4,
        4,
        4
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        15,
        16,
        18,
        12,
        13,
        14,
        19,
        17,
        6,
        7,
        22,
        0,
        1,
        2,
        21,
        8,
        9,
        10,
        23,
        3,
        4,
        5,
        20,
        11
      ]
    }
  ],
  "YMO_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 18,
      "hasRenderSurface": true,
      "rowCount": 3,
      "columnCount": 6,
      "closedColumns": true,
      "sourceVertexOrder": [
        13,
        12,
        17,
        14,
        15,
        16,
        4,
        5,
        3,
        1,
        0,
        2,
        10,
        11,
        9,
        7,
        6,
        8
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        13,
        12,
        17,
        14,
        15,
        16,
        4,
        5,
        3,
        1,
        0,
        2,
        10,
        11,
        9,
        7,
        6,
        8
      ]
    }
  ],
  "YPA_L": [
    {
      "controlType": -73,
      "renderType": 88,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    },
    {
      "controlType": -74,
      "renderType": 89,
      "vertexCount": 12,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 6,
      "closedColumns": false,
      "sourceVertexOrder": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        7,
        9,
        8,
        10,
        11,
        6,
        1,
        3,
        2,
        4,
        5,
        0
      ]
    }
  ],
  "YYI_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 28,
      "hasRenderSurface": true,
      "rowCount": 4,
      "columnCount": 7,
      "closedColumns": true,
      "sourceVertexOrder": [
        4,
        6,
        5,
        3,
        1,
        0,
        2,
        24,
        22,
        21,
        23,
        25,
        27,
        26,
        16,
        18,
        17,
        15,
        13,
        12,
        14,
        9,
        11,
        20,
        8,
        7,
        19,
        10
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        3,
        3,
        3,
        3
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        4,
        6,
        5,
        3,
        1,
        0,
        2,
        24,
        22,
        21,
        23,
        25,
        27,
        26,
        16,
        18,
        17,
        15,
        13,
        12,
        14,
        9,
        11,
        20,
        8,
        7,
        19,
        10
      ]
    }
  ],
  "ZZE_L": [
    {
      "controlType": -70,
      "renderType": 90,
      "vertexCount": 20,
      "hasRenderSurface": true,
      "rowCount": 2,
      "columnCount": 10,
      "closedColumns": true,
      "sourceVertexOrder": [
        3,
        7,
        18,
        15,
        11,
        13,
        12,
        19,
        5,
        4,
        2,
        6,
        17,
        14,
        9,
        10,
        8,
        16,
        0,
        1
      ],
      "anchorBindings": [
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "anchorSelectors": [
        5,
        5
      ],
      "collisionMask": 65535,
      "latticeToRenderVertexMap": [
        3,
        7,
        18,
        15,
        11,
        13,
        12,
        19,
        5,
        4,
        2,
        6,
        17,
        14,
        9,
        10,
        8,
        16,
        0,
        1
      ]
    }
  ]
}
);
